module.exports = __webpack_public_path__ + "static/home-bg-desktop-294a45988c8ee4dc95b07eec3abc950b.jpg";